var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c("h3", [_vm._v("Report for the year : " + _vm._s(_vm.year))]),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Filter by Month:",
            "label-cols-sm": "6",
            "label-align-sm": "right",
            "label-size": "sm",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.monthFilterOptions, size: "sm" },
            on: { change: _vm.filterByMonth },
            model: {
              value: _vm.selectedMonth,
              callback: function ($$v) {
                _vm.selectedMonth = $$v
              },
              expression: "selectedMonth",
            },
          }),
        ],
        1
      ),
      _c("b-table", {
        staticClass: "mb-0",
        attrs: {
          responsive: "",
          items: _vm.filteredSalesData,
          fields: _vm.fields,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(salesAmount)",
            fn: function (data) {
              return [
                _vm._v(" " + _vm._s(data.item.salesAmount.toFixed(2)) + " "),
              ]
            },
          },
          {
            key: "cell(revenueAmount)",
            fn: function (data) {
              return [
                _vm._v(" " + _vm._s(data.item.revenueAmount.toFixed(2)) + " "),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }